import { Inbox, CalendarClock, MessageSquareOff } from "lucide-react";
import { useTranslation } from "@thyra/landing-i18n";
import { SectionHeader } from "./ui/SectionHeader";

const PROBLEMS = [
  { id: "inbox", Icon: Inbox },
  { id: "calendar", Icon: CalendarClock },
  { id: "ai", Icon: MessageSquareOff },
] as const;

export function ProblemSection() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-background-muted py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow={t("problem.eyebrow")}
          title={t("problem.title")}
          description={t("problem.description")}
        />
        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {PROBLEMS.map(({ id, Icon }, i) => (
            <div
              key={id}
              data-aos="fade-up"
              data-aos-delay={i * 90}
              className="marketing-card marketing-card-hover group p-6"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 transition-colors group-hover:bg-primary/15">
                <Icon className="h-5 w-5 text-primary" />
              </div>
              <h3 className="mt-4 text-lg font-semibold tracking-tight text-card-foreground">
                {t(`problem.items.${id}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {t(`problem.items.${id}.body`)}
              </p>
            </div>
          ))}
        </div>
        <p className="mx-auto mt-12 max-w-xl text-center text-lg font-medium text-foreground">
          {t("problem.closing")}
        </p>
      </div>
    </section>
  );
}
